// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"1d147322","334":"53bddde8"}[chunkId] + ".chunk.js";
};